import { apiClient } from "@/lib/apiClient";
import {
  CreateMetafieldDto,
  UpdateMetafieldDto,
} from "@/types/models/metafield";

export const metafieldService = {
  async getMetafields(params: { page?: number; limit?: number } = {}) {
    const apiParams: Record<string, string> = {};

    if (params.page) apiParams.page = params.page.toString();
    if (params.limit) apiParams.limit = params.limit.toString();

    return await apiClient.getPaginated(
      "/api/v1/admin/:storeId/settings/metafields",
      apiParams,
    );
  },

  async createMetafield(data: CreateMetafieldDto) {
    return await apiClient.post(
      "/api/v1/admin/:storeId/settings/metafields",
      data,
    );
  },

  async updateMetafield(key: string, data: UpdateMetafieldDto) {
    return await apiClient.put(
      `/api/v1/admin/:storeId/settings/metafields/${key}`,
      data,
    );
  },

  async deleteMetafield(id: string) {
    return await apiClient.delete(
      `/api/v1/admin/:storeId/settings/metafields/${id}`,
    );
  },

  async checkMetafieldKeyUniqueness(key: string, appliedTo: string) {
    return await apiClient.get(
      `/api/v1/admin/:storeId/settings/metafields/check-uniqueness`,
      {
        key,
        applied_to: appliedTo,
      },
    );
  },
};
